import { DISPLAY_ALT_CHARGES, SET_ALT_CHARGES } from '../actionTypes/AlternateChargeActionTypes';

export default function alternateChargeReducer(state = {}, action) {
    // NOSONAR
    switch (action.type) {
        case SET_ALT_CHARGES:
            return { ...state, altCharges: action.altCharges };
        case DISPLAY_ALT_CHARGES:
            return { ...state, isDisplayAltCharges: action.isDisplayAltCharges };
        default:
            return state;
    }
}
